import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import { useTranslate } from "src/locales";

function CanScaleFooter() {
  const { t } = useTranslate();
  return <ByzMuiTypography isTitle={false} >{t("can-scale.note-text")}</ByzMuiTypography>
}

export default CanScaleFooter;  
